<template>
  <div class="invoice">
    <div class="title">电子普通发票</div>
    <div class="tips">
      提示：修改或完善开票信息，请前往 发票管理->
      <span class="text-button clickable" @click="toInvoiceHelp">发票助手</span>
    </div>
    <div class="content">
      <div class="invoice-form">
        <el-form :model="form" label-suffix="：" label-width="140px">
          <el-form-item label="单位名称" prop="companyName">
            <span>{{ form.companyName || '-' }}</span>
          </el-form-item>
          <el-form-item label="纳税人识别号" prop="companyTaxNo">
            <span>{{ form.companyTaxNo || '-' }}</span>
          </el-form-item>
          <el-form-item label="单位地址" prop="companyAddress">
            <span>{{ form.companyAddress || '-' }}</span>
          </el-form-item>
          <el-form-item label="单位电话" prop="companyMobile">
            <span>{{ form.companyMobile || '-' }}</span>
          </el-form-item>
          <el-form-item label="开户银行" prop="companyBankName">
            <span>{{ form.companyBankName || '-' }}</span>
          </el-form-item>
          <el-form-item label="银行账号" prop="companyBankAccount">
            <span>{{ form.companyBankAccount || '-' }}</span>
          </el-form-item>
          <el-form-item label="收票人手机号" prop="employeeMobile">
            <span>{{ form.employeeMobile || '-' }}</span>
          </el-form-item>
          <el-form-item label="收票人邮箱" prop="employeeEmail">
            <span>{{ form.employeeEmail || '-' }}</span>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
// 工具
import { strUtil } from 'jczh-ui'
import { invoiceTypeDict, isCompanyDict } from '@/dictionary/financial'
import { getInvoiceApi } from '@/api/financial'

/**
 * @description 电子普通发票组件
 */
export default {
  name: 'GeneralInvoice',

  filters: {
    bankFilter(bankCard) {
      return bankCard ? strUtil.bankCardDivision(bankCard) : '-'
    }
  },

  props: {
    companyId: {
      type: [String, Number],
      required: true
    },

    // 发票地址id
    invoiceAddressId: {
      type: [String, Number],
      default: ''
    },

    // 当前用户是否为企业员工
    isEmployee: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      form: {
        id: undefined,
        invoiceType: invoiceTypeDict.GENERAL_ELECTRONIC_INVOICE.value,
        companyId: undefined,
        companyName: undefined,
        companyTaxNo: undefined,
        companyAddress: undefined,
        companyMobile: undefined,
        companyBankName: undefined,
        companyBankAccount: undefined,
        employeeMobile: undefined,
        employeeEmail: undefined,
        isCompany: isCompanyDict.COMPANY.value
      }
    }
  },

  created() {
    this.getInvoiceInfo()
  },

  methods: {
    // 获取发票信息
    getInvoiceInfo() {
      getInvoiceApi({
        type: invoiceTypeDict.GENERAL_ELECTRONIC_INVOICE.value,
        companyId: this.companyId,
        invoiceAddressId: this.invoiceAddressId,
        isCompany: this.isEmployee
          ? isCompanyDict.COMPANY.value
          : isCompanyDict.PERSONAL.value
      })
        .then(res => {
          const formKeys = Object.keys(this.form)
          formKeys.forEach(key => {
            this.form[key] = res.data[key]
          })
          this.form.invoiceType =
            invoiceTypeDict.GENERAL_ELECTRONIC_INVOICE.value
          this.$emit('getInvoiceInfo', this.form)
        })
        .catch(err => {
          this.$message.error(err?.data?.message || '获取电子普通发票信息失败')
        })
    },

    toInvoiceHelp() {
      this.$emit('toInvoiceHelp')
    }
  }
}
</script>

<style scoped lang="scss">
.invoice {
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-size: 20px;
    color: $text-color;
  }
  .tips {
    color: $third-text-color;
    margin: 8px 0 24px;

    .text-button {
      &:hover {
        color: $primary-color;
        opacity: 1;
      }
    }
  }
  .content {
    .invoice-form {
      ::v-deep .el-form {
        width: 400px;
        .el-form-item {
          margin-bottom: 20px;
        }

        &.detail-form {
          .el-form-item {
            margin-bottom: 0;
          }
        }
      }

      .invoice-form-operate {
        text-align: center;
      }
    }
  }
}
</style>
